require('intersection-observer');

export default {
  instance: null,
  observeEls(els, callback, unvisiableCb) {
    this.instance = new IntersectionObserver(
      function (entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            callback && callback(entry);
          } else {
            unvisiableCb && unvisiableCb();
          }
        });
      },
      {
        threshold: 0.001, // 只要展现面积达到 0.1% 的宝贝元素
      },
    );
    this.instance.POLL_INTERVAL = 200;
    Array.from(els).forEach(item => this.instance.observe(item));
  },
  unObserve(els) {
    this.instance &&
      Array.from(els).forEach(item => this.instance.unobserve(item));
  },
};
